<template>
  <!-- 新版 CTR 模式 -->
  <div
    class="base-wrapper index-ctr-wrap"
    :class="[payDeferStyleType === '3' || payDeferStyleType === '' ? 'index-ctr-wrap-new' : '']"
  >
    <!-- 关闭按钮 -->
    <img
      class="half-drawer-close"
      src="../../assets/close.png"
      @click="cancelHandler"
    />
    <!-- 内容 -->
    <article>
      <img
        v-if="pageData.bannerPicLink"
        class="banner-pic-link"
        :src="pageData.bannerPicLink"
      />
    </article>

    <!-- 底部区域 -->
    <footer>
      <a
        class="deduction-order"
        @click="showOrderPage"
        >设置扣款顺序</a
      >
      <!-- 协议 -->
      <div
        v-if="agreementInfo.length"
        class="agreement-wrap"
      >
        <span>点击按钮即表示你已阅读并同意</span>
        <span
          class="highlight"
          @click="showAgreementPage()"
        >
          先用后付相关协议</span
        >
      </div>
      <!-- 开通按钮 -->
      <div class="button-line">
        <button
          class="go-service"
          @click="qualifyDispatcher"
        >
          {{ pageData.buttonText || '确认，去支付' }}
        </button>
        <div
          v-if="marketingInfo.bubbleText"
          class="badge ellipsis"
        >
          {{ marketingInfo.bubbleText }}
        </div>
      </div>
      <!-- 不开通，直接支付按钮 -->
      <div class="button-line bottom-line">
        <button
          class="go-pay"
          @click="goPay"
        >
          {{ pageData.subButtonText || '放弃，去支付' }}
        </button>
      </div>
    </footer>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { normalizeError } from '@mx/pay-common';
import pgyReport from '@fdfe/pgy-report-web';
import { toast } from '@mx/vix';
import {
  env,
  bridge,
  homePage,
  metricPoints,
  monitor,
  OpenType,
  PageType,
  ReversionId,
  VisiblePage,
  NSFUrl,
  getDeductionOrderPageUrl,
} from '@/common';
import {
  fetchGuideSign,
  cancelDefer,
  showErrorModal,
  initPagePromise,
  fetchQualifyDispatcher,
  downgradeStandardCashier,
} from '@/service';
import { lx } from '@/analytic';
import { bids, cids } from '@/analytic/lx-constants';

export default Vue.extend({
  name: 'App',
  props: {
    openType: {
      type: Number,
      default: OpenType.InpaySign,
    },
  },
  data() {
    return {
      pageData: {} as HomePageType,
      reversionId: env.reversionId,
      adData: {} as Record<string, unknown>,
      adEventTracking: {} as Record<string, unknown>,
      payDeferStyleType: '',
    };
  },
  computed: {
    pageType(): PageType {
      return this.openType === OpenType.IndependenceSign ? PageType.home : PageType.index;
    },
    // 扣费账户相关数据
    deductOrderInfo(): DeductOrderInfoType {
      return this.pageData.deductOrderInfo || {};
    },
    // 营销气泡数据
    marketingInfo(): MarketingInfoType {
      return this.pageData.marketingInfo || {};
    },
    // 协议文案及链接
    agreementInfo(): AgreementType[] {
      return this.pageData.agreementInfo || [];
    },
  },
  created() {
    // 设置页面签约流程
    env.setOpenType(this.openType);
    env.setPerformanceOpenType();
    const nsfUrl = this.reversionId === ReversionId.ImproveCTR ? NSFUrl.Index : '';
    initPagePromise(this.pageType, nsfUrl)
      .then(this.init)
      .then(() => {
        if (env.hideHalfPage) {
          fetchGuideSign();
        }
      })
      .catch((error: any) => {
        monitor.captureAjaxErrorMessage(`[api]${this.pageType}签约组件调用异常`, { error: normalizeError(error) });
      });
  },
  mounted() {
    bridge.setLLButton(this.cancelHandler);
  },
  methods: {
    init() {
      const scorePlanId =
        this.reversionId === ReversionId.ImproveCTR ? { scorePlanId: env.coreBusinessParams.scorePlanId } : {};
      const openType = this.reversionId === ReversionId.ImproveCTR ? env.performanceOpenType : env.openType;
      const apiHomePage: Promise<HomePageType> =
        this.reversionId === ReversionId.ImproveCTR
          ? this.$store.dispatch({ type: 'paydefercashier/getHomePageData' }, { root: true })
          : homePage({
              ...env.inpayBasicBusinessParams,
              ...scorePlanId,
              outer_business_data: env.outerBusinessData, // payDeferHomePage 接口暂未通过解析此字段来获取 scorePlanId，后端后续需调整
              openType,
              entry: env.entry,
            });
      return apiHomePage
        .then((res) => {
          this.pageData = res || {};
          // 保存商户号，后续接口使用
          env.setIphPayMerchantNo(res.iphPayMerchantNo);
          env.setFreePasswordFlag(res.freePassword);
          // 保存 utmSource, 获客链路优化调整优先使用url上的utm
          const utmSource = env.hideHalfPage ? env.urlUtmSource : res.marketingInfo?.utmSource;
          env.setUtmSource(utmSource || '');
          env.setPayDeferStyleType(res.payDeferStyleType || '');
          this.payDeferStyleType = env.payDeferStyleType;

          // 后端下发 subPayTypeDescription 字段时上报曝光，目前所有都会下发 - 20210917
          if (this.pageData?.deductOrderInfo?.subPayTypeDescription) {
            lx.mv(bids.showOrderBtn, {}, { cid: cids.index });
          }
          if (this.pageData?.marketingInfo?.bubbleText) {
            lx.mv(bids.bubbleTextMV, {}, { cid: cids.index });
          }
          const duration = performance.now();
          lx.pv(cids.index, { duration, paramTunnelTime: Date.now() - env.paramTunnelTime });
          // stat_time 里第一个值是半页容器起始点， 暂时注释，待native 修复后调整上报逻辑
          // const statTimeStart = env.statCommonParams.stat_time?.split(',')?.[0] || 0;
          // 使用 NEO 返回的起始点上报数据，金服 TTI，对应 21 测速点
          // monitor.reportPoint(20, Date.now() - statTimeStart);
          monitor.reportPoint(20);
          monitor.reportMetric(metricPoints.showIndexPage);
          pgyReport.report('show', 0, this.pageData, {
            val_cid: cids.index,
            val_bid: bids.signPayBtnMV,
            category: 'pay',
            fin_biz: 'pay',
            ...lx.lxCommonParams(),
          });
          if (env.freePassword) {
            toast.show('text', '安全检测已通过');
          }
        })
        .catch((error) => {
          monitor.captureAjaxErrorMessage('[api]首页接口请求失败', { error: normalizeError(error) });
          showErrorModal({ resultData: error });
        });
    },

    guideSignPayHandler() {
      fetchGuideSign();
    },

    qualifyDispatcher() {
      env.setBizSerialNo('');
      pgyReport.report('click', 0, this.pageData, {
        val_cid: cids.index,
        val_bid: bids.signPayBtn,
        category: 'pay',
        fin_biz: 'pay',
        ...lx.lxCommonParams(),
      });
      fetchQualifyDispatcher();
    },

    showAgreementPage() {
      this.$emit('toggleVisiblePage', VisiblePage.agreement, this.agreementInfo, 0);
    },

    showOrderPage() {
      lx.mc(bids.clickOrderBtn, {}, { cid: cids.index });
      // this.$emit('toggleVisiblePage', VisiblePage.order, link);
      getDeductionOrderPageUrl(this.pageData.mtPlanId || '');
    },

    cancelHandler() {
      cancelDefer();
    },

    goPay() {
      lx.mc(bids.goPayBtn, {}, { cid: cids.index });
      downgradeStandardCashier();
    },
  },
});
</script>

<style lang="less" scoped>
@import '../../styles/variable.less';
.index-ctr-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 24px 24px 0 0;
  article {
    position: relative;
    text-align: center;
    min-height: 30vh;
    .banner-pic-link {
      width: 100%;
      height: auto;
      max-height: 50vh;
      margin-top: -2px;
    }
  }
  footer {
    padding: 0 32px;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    text-align: center;
    .deduction-order {
      margin-top: 80px;
      display: block;
      font-weight: 400;
      font-size: 24px;
      color: #0a77f5;
      line-height: 36px;
    }
    .agreement-wrap {
      margin-top: 18px;
      font-weight: 400;
      font-size: 24px;
      color: rgba(0, 0, 0, 0.35);
      line-height: 36px;
      margin-bottom: 24px;
    }
    .go-service {
      height: 0.96rem;
      font-weight: 500;
      font-size: 32px;
      color: rgba(0, 0, 0, 0.9);
      border-radius: 48px;
    }
    .bottom-line {
      margin: 28px 0 28px;
      .go-pay {
        height: 52px;
        line-height: 28px;
        background: transparent;
        font-size: 28px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.9);
      }
    }
  }
}
.index-ctr-wrap-new {
  footer {
    width: 100%;
    position: absolute;
    bottom: 0;
  }
  article {
    .banner-pic-link {
      width: 100%;
      height: auto;
      display: block;
      max-height: 70vh;
      margin-top: 0;
    }
  }
}
</style>
